import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LocalStorageService } from 'src/app/services/localStorage.service';

@Component({
  selector: 'app-edit-info',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './edit-info.component.html',
  styleUrls: ['./edit-info.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EditInfoComponent {
  public closeEditInfo = output();
  public gotItEditInfo = output();
  
  private _localStorageService = inject(LocalStorageService);

  public handleCloseClick() {
    this.closeEditInfo.emit();
  }
  
  public handleGotItClick() {
    console.log('Got it clicked');
    this.gotItEditInfo.emit();
    this._localStorageService.setItem('showEditInfo', false);
  }
}
